import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useState } from "react";
import Hide from "@engineering/icons/hide";
import Show from "@engineering/icons/show";
import { ErrorMessage } from "../ErrorMessage";
import { Wrapper, Label, Input as StyledInput, ToggleButton } from "./Input.styles";
var defaultProps = {
    iconPosition: "right"
};
var Input = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var type = _param.type, label = _param.label, hiddenLabel = _param.hiddenLabel, forcedLabel = _param.forcedLabel, icon = _param.icon, iconPosition = _param.iconPosition, error = _param.error, id = _param.id, value = _param.value, placeholder = _param.placeholder, appearActive = _param.appearActive, disabled = _param.disabled, readOnly = _param.readOnly, required = _param.required, onChange = _param.onChange, className = _param.className, props = _object_without_properties(_param, [
        "type",
        "label",
        "hiddenLabel",
        "forcedLabel",
        "icon",
        "iconPosition",
        "error",
        "id",
        "value",
        "placeholder",
        "appearActive",
        "disabled",
        "readOnly",
        "required",
        "onChange",
        "className"
    ]);
    var _$ref = useState(!!value), isFilled = _$ref[0], setIsFilled = _$ref[1];
    var _$ref1 = useState(false), showValue = _$ref1[0], setShowValue = _$ref1[1];
    var isInvalid = !!error;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(Label, {
                htmlFor: id,
                isHidden: !!hiddenLabel,
                isFilled: isFilled || !!forcedLabel,
                isInvalid: isInvalid,
                isDisabled: disabled || readOnly,
                children: label
            }),
            /*#__PURE__*/ _jsx(StyledInput, _object_spread_props(_object_spread({
                iconPosition: !!icon && iconPosition || undefined,
                type: showValue ? "text" : type
            }, props), {
                placeholder: placeholder || label,
                id: id,
                ref: ref,
                value: value,
                disabled: disabled,
                readOnly: readOnly,
                required: required,
                "aria-invalid": isInvalid ? "true" : undefined,
                "aria-required": required ? "true" : undefined,
                isInvalid: isInvalid,
                isFilled: isFilled,
                isActive: !!appearActive,
                onChange: function(event) {
                    setIsFilled(!!event.target.value);
                    if (typeof onChange === "function") {
                        onChange(event);
                    }
                }
            })),
            icon,
            type === "password" && /*#__PURE__*/ _jsx(ToggleButton, {
                type: "button",
                isInvalid: isInvalid,
                "data-testid": "".concat(id, "-visibility-toggle"),
                "aria-label": showValue ? "Hide" : "Show",
                onClick: function() {
                    setShowValue(!showValue);
                },
                children: showValue ? /*#__PURE__*/ _jsx(Show, {}) : /*#__PURE__*/ _jsx(Hide, {})
            }),
            isInvalid && /*#__PURE__*/ _jsxs(ErrorMessage, {
                children: [
                    " ",
                    error
                ]
            })
        ]
    });
});
Input.defaultProps = defaultProps;
export { Input };
